import {
  ACCOUNT_UPDATE,
  // CREATE_PAYMENT,
  GET_ACCOUNT,
  GET_ALL_PLANS,
  GET_FOLLOW_INTEREST,
  GET_FOLLOWING_DATA,
  GET_MODEL_INTEREST_DATA,
  GET_PREDICTION,
  GET_SEARCH_TAGS_DATA,
  GET_TAGS_DATA,
  GET_TOP_STORIES,
  GET_TRANDING,
  // GET_VERIFIED,
  GET_ELECTION_TYPE,
  INDIA_POLL_RESULT,
  POST_INTEREST,
  POST_SUBSCRIPTION,
  SELECTED_INTERESTED_DATA,
  SELECTED_PLAN,
  SELECTED_TAGS_ISBOREDED,
  GET_STATE_BY_ID,
  GET_STATE_BY_POLL_DATA,
  CANADA_POLL_RESULT,
   SET_LOADING,
  CLEAR_LOADING
} from "../actions/type";

const initialState = {
  topStoriesData: [],
  followyourinterest: [],
  followingData: [],
  selectedInterest: "",
  getTags: [],
  searchTags: "",
  modelinterestData: [],
  getaccount: {},
  getElectionTypeResponse: {},
  tranding: [],
  isBorededSelectedTags: [],
  confirmUpdateAccount: "",
  postInterestRes: "",
  ShowAllPlans: [],
  selectSubscription: "",
  verifiedPayment: null,
  paymentIntent: "",
  predictionResponse: "",
  indiaPollsResult: {},
  canadaPollsResult: {},
  getStateByIdResponse: "",
  getStateByPollDataResponse: "",
  isLoading: false,
};

const privateApiReducer = (state = initialState, action) => {
  // console.log("action",action?.payload?.data);

  switch (action.type) {
     case SET_LOADING:
      return { ...state, isLoading: true };
      
    case CLEAR_LOADING:
      return { ...state, isLoading: false };
    case GET_TOP_STORIES:
      return { ...state, topStoriesData: action?.payload?.data };
    case GET_TRANDING:
      return { ...state, tranding: action?.payload?.data };
    case GET_FOLLOW_INTEREST:
      return { ...state, followyourinterest: action.payload?.data };
    case INDIA_POLL_RESULT:
      return { ...state, indiaPollsResult: action.payload?.data };
    case CANADA_POLL_RESULT:
      return { ...state, canadaPollsResult: action.payload?.data };
    case POST_INTEREST:
      return { ...state, postInterestRes: action.payload?.msg };
    case GET_FOLLOWING_DATA:
      return { ...state, followingData: action.payload?.data };
    case SELECTED_INTERESTED_DATA:
      return { ...state, selectedInterest: action?.payload?.data };
    case GET_TAGS_DATA:
      return { ...state, getTags: action?.payload?.data };
    case GET_SEARCH_TAGS_DATA:
      return { ...state, searchTags: action?.payload?.data };
    case GET_MODEL_INTEREST_DATA:
      return { ...state, modelinterestData: action.payload?.data };
    case ACCOUNT_UPDATE:
      return { ...state, confirmUpdateAccount: action?.payload?.msg };
    case GET_ACCOUNT:
      return { ...state, getaccount: action?.payload?.data };
    case SELECTED_TAGS_ISBOREDED:
      return { ...state, isBorededSelectedTags: action?.payload?.data };
    case GET_ALL_PLANS:
      return { ...state, ShowAllPlans: action?.payload?.data };
    case SELECTED_PLAN:
      return { ...state, selectSubscription: action?.payload?.data };
    case POST_SUBSCRIPTION:
      return { ...state, subscriptiondata: action?.payload?.data };
    // case GET_VERIFIED:
    //   return { ...state, verifiedPayment: action?.payload };
    // case CREATE_PAYMENT:
    //   return { ...state, paymentIntent: action?.payload };
    case GET_PREDICTION:
      return { ...state, predictionResponse: action?.payload };
    case GET_ELECTION_TYPE:
      return { ...state, getElectionTypeResponse: action?.payload };
    case GET_STATE_BY_ID:
      return { ...state, getStateByIdResponse: action?.payload };
    case GET_STATE_BY_POLL_DATA:
      return { ...state, getStateByPollDataResponse: action?.payload };
    default:
      return state;
  }
};
export default privateApiReducer;
